// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a79fbbd9","453":"e073a5ae","455":"2b438294","977":"b82e8471"}[chunkId] + ".chunk.js";
};